<div class="study-profile-container ps-3 pe-3 pt-3" [ngClass]="{
                'disabled-content':
                  isPageExpire
              }">
  <div class="logo active"></div>
  <div class="row justify-content-center position-relative">
    <div class="col-md-12 mt-2">
      <div class="tab-wrapper d-flex justify-content-center align-items-center">
        <!-- Centered Buttons (unchanged) -->
        <div class="tab-button text-primary border-primary box cursor-pointer me-4 p-1 text-center border fs-xs-12"
             [ngClass]="{'bg-primary text-white active': viewMode === ViewMode.IMAGES}"
             (click)="setViewMode(ViewMode.IMAGES)">
          IMAGES
        </div>
        <div class="tab-button text-warning border-warning box cursor-pointer p-1 me-4 text-center border fs-xs-12"
             [ngClass]="{'bg-warning text-white active': viewMode === ViewMode.MEDIA}"
             (click)="setViewMode(ViewMode.MEDIA)">
          MEDIA
        </div>
        <div class="tab-button text-success border-success box cursor-pointer p-1 text-center border fs-xs-12"
             [ngClass]="{'bg-success text-white active': viewMode === ViewMode.REPORTS}"
             (click)="setViewMode(ViewMode.REPORTS)">
          REPORTS
        </div>
      </div>
      <!-- Download Button -->
      <div class="download-button position-absolute end-12 top-16 p-1">
        <button class="btn btn-outline-primary fs-xs-12" (click)="downloadStudyData()">
          DOWNLOAD&nbsp;&nbsp;<i class="fa fa-download"></i>
        </button>
      </div>
    </div>
  </div>

  <ng-container>
    <div class="row justify-content-center mt-4" [ngClass]="{ 'hidden': viewMode !== ViewMode.IMAGES }">
      <div class="col-12">
        <iframe [src]="sanitizedUrl"
                width="100%"
                scrolling="yes"
                frameborder="0"
                id="ifrStudyViewer"
                allowfullscreen></iframe>
      </div>

    </div>


  </ng-container>

  <ng-container *ngIf="viewMode === ViewMode.MEDIA">
    <div class="table-resposive data-grid table-fix-head mt-3 p-0">
      <table class="table table-borded">
        <thead class="mat-header-row">
          <tr>
            <th class="cursor-pointer" (click)="sortTable('originalFileName')">File Name <i class="fa fa-sort"></i></th>
            <th>Type</th>
            <th class="cursor-pointer" (click)="sortTable('createdByUser?.name')">Uploaded BY <i class="fa fa-sort"></i></th>
            <th class="cursor-pointer" (click)="sortTable('createdDate')">Uploaded Date / Time <i class="fa fa-sort"></i></th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let studyFile of dicomFiles" class="mat-row">

            <td>{{ studyFile.originalFileName }}</td>
            <td>VIDEO</td>
            <td>{{ studyFile.createdByUser?.name }}</td>
            <td>{{ studyFile.createdDate | date : dateFormat }}</td>
            <td>
              <button class="btn btn-outline-primary me-1 btn-sm" (click)="viewScope(studyFile)"><i class="fa fa-eye"></i></button>
            </td>

          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

  <ng-container *ngIf="viewMode === ViewMode.REPORTS">
    <div class="table-resposive data-grid table-fix-head mt-3 p-0">
      <table class="table table-borded">
        <thead class="mat-header-row">
          <tr>
            <th class="cursor-pointer" (click)="sortTable('originalFileName')">File Name <i class="fa fa-sort"></i></th>
            <th class="cursor-pointer" (click)="sortTable('documentTypeName')">Doc Type <i class="fa fa-sort"></i></th>
            <th>Format</th>
            <th class="cursor-pointer" (click)="sortTable('createdByUser?.name')">Uploaded BY <i class="fa fa-sort"></i></th>
            <th class="cursor-pointer" (click)="sortTable('createdDate')">Uploaded Date / Time <i class="fa fa-sort"></i></th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let studyFile of dicomFiles" class="mat-row">

            <td>{{ studyFile.originalFileName }}</td>
            <td>
              <span *ngIf="studyFile.documentTypeName">{{ studyFile.documentTypeName }}</span>
            </td>
            <td>PDF</td>
            <td>{{ studyFile.createdByUser?.name }}</td>
            <td>{{ studyFile.createdDate | date : dateFormat }}</td>
            <td>
              <button class="btn btn-outline-primary me-1 btn-sm" (click)="viewPdf(studyFile)"><i class="fa fa-eye"></i></button>
            </td>

          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
</div>
